import axios from "../axios/axios";

/**
 * Fetches service place codes from the backend
 * @returns Promise with service place data
 */
export const getServicePlaces = async () => {
  try {
    const { data } = await axios.get("/service-place");
    return data;
  } catch (e: any) {
    throw e?.response?.data;
  }
};

const ServicePlaceService = {
  getServicePlaces
};

export default ServicePlaceService;
